
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.54 23.11l-2.26 2.26A22.75 22.75 0 0149 16.81a2.06 2.06 0 002.78.26 2.07 2.07 0 00.3-3A26.87 26.87 0 006 25.51l-2.47-2.42a2.08 2.08 0 00-2.92 0 2.06 2.06 0 000 2.91l5.8 5.81a2.31 2.31 0 003.25 0l5.8-5.81a2.05 2.05 0 000-2.93 2.07 2.07 0 00-2.92.04zM54.35 32.14l-5.8 5.8a2.09 2.09 0 000 2.93 2.08 2.08 0 002.92 0l2.3-2.3a22.73 22.73 0 01-39.07 8.19 2.07 2.07 0 00-2.77-.32 2.07 2.07 0 00-.36 3 26.86 26.86 0 0046.49-11l2.41 2.41a2.07 2.07 0 002.92 0 2.08 2.08 0 000-2.94l-5.8-5.8a2.29 2.29 0 00-3.24.03zm1.53 4.33l.1-.1.16.15z"}})])
          )
        }
      }
    